module.exports = __webpack_public_path__ + "img/credit-card-up.864b3991.svg";